<template lang="pug">
div
  Form(:data="area", :isSubmitting="isSubmitting", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useAreaEdit from './useAreaEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { show, update, area, isSubmitting } = useAreaEdit()

    onMounted(show)

    return {
      area,
      update,
      isSubmitting,
    }
  },
}
</script>
